<template>
  <div class="row tasks-view" :class="{'task-view-load': isLoadData}">
    <div class="col">
      <div class="row">
        <div class="col">
          <form class="form-inline py-2 justify-content-end" @submit.prevent>
            <div class="input-group with-clear-icon">
              <input type="text" class="form-control" v-model="searchText" />
              <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
              <div class="input-group-append">
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th
              v-for="column in tableColumns"
              :key="column.fieldName"
              @click="columnClick(column.sortName)"
              :class="{'sort-asc': column.sortName === $store.getters.tasksSortColumn && $store.getters.tasksSortDirection === 'ASC',
                        'sort-desc': column.sortName === $store.getters.tasksSortColumn && $store.getters.tasksSortDirection === 'DESC',
                        'sort': column.sortName !== $store.getters.tasksSortColumn }"
              :style="{'width': (column.width* 100 / tableColumns.map(x=>x.width).reduce((a, b) => a + b))  + '%'}"
            >
              <div class="table-th">{{$t(column.name)}}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in showedRows"
            :key="row.taskId"
            :class="{'tr-overdue': row.overdue, 'tr-hot': row.hot}"
            @click="rowClick(row.taskId)"
          >
            <td v-for="cell in row.cells" :key="cell.id" :class="[cell.cellClasses]">
              <div class="td-content td-content-lg" :title="cell.value">
                <template v-if="cell.fieldName === 'ctid'">
                  {{cell.value}}
                </template>
                <template v-else-if="cell.fieldName === 'taskName'">
                  <router-link :to="{ path: `/ad-agent/view-task/${row.taskId}`}">{{cell.value}}</router-link>
                </template>
                 <template v-else-if="cell.fieldName === 'name'">
                  <router-link v-if="status !== 'incoming'" :to="{ path: `/ad-agent/view-request/${row.taskId}`}">{{cell.value}}</router-link>
                  <router-link v-else :to="{ path: `/view-request/${row.taskId}`}">{{cell.value}}</router-link>
                </template>
                <template v-else>{{cell.value}}</template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import tableHelper from '../../../helpers/tableHelper'
import _ from 'lodash'
import { mapActions } from 'vuex'

const sortTypes = {
  ASC: 'ASC',
  DESC: 'DESC'
}

const countRowsToShow = 60

export default {
  name: 'AdAgentTasks',
  props: {
    status: {
      default: 'accepted'
    }
  },
  data: () => {
    return {
      searchText: '',
      lazySearchText: '',
      activeFilterName: '',
      isLoadData: false,
      countRowsToShow: countRowsToShow
    }
  },
  computed: {
    tableColumns: function () {
      switch (this.status) {
        case 'accepted':
          return tableHelper.getAdAgentTasksColumns()
        case 'outgoing': {
          const isAdAgent = true
          return tableHelper.getRequestColumns(isAdAgent)
        }
        case 'incoming': {
          const isAdAgent = false
          return tableHelper.getRequestColumns(isAdAgent)
        }
        default:
          return tableHelper.getAdAgentTasksColumns()
      }
    },
    formattedRows: function () {
      let tasks = []
      const rows = []
      switch (this.status) {
        case 'accepted':
          tasks = this.$store.getters.userAcceptedTasks
          break
        case 'outgoing':
        case 'incoming':
          tasks = this.$store.getters.userOutgoingTasks
          break
      }

      switch (this.status) {
        case 'accepted':
          tasks.forEach(function (task) {
            const row = tableHelper.getRow(task, this.tableColumns)
            rows.push(row)
          }, this)
          break
        case 'outgoing':
        case 'incoming':
          tasks.forEach(function (task) {
            const row = tableHelper.getRequestRow(task, this.tableColumns)
            rows.push(row)
          }, this)
          break
      }

      return rows
    },
    orderedRows: function () {
      let sortFieldName = this.$store.getters.tasksSortColumn

      if (this.tableColumns.every(x => x.fieldName !== sortFieldName)) {
        sortFieldName = this.tableColumns[0].fieldName
      }

      let sorterdRows = _.sortBy(this.formattedRows, function (row) {
        return _.find(row.cells, { sortName: sortFieldName }).sortValue
      })

      if (this.$store.getters.tasksSortDirection === sortTypes.DESC) {
        sorterdRows.reverse()
      }

      if (this.status !== 'archived' || this.status !== 'outgoing' || this.status !== 'incoming') {
        sorterdRows = _.sortBy(sorterdRows, function (row) {
          return !row.hot && !row.overdue
        })
        sorterdRows = _.sortBy(sorterdRows, function (row) {
          return !row.overdue
        })
      }

      return sorterdRows
    },
    tableRows: function () {
      if (this.lazySearchText) {
        var filteredRows = this.orderedRows.filter(function (row) {
          return row.cells.some(function (cell) {
            return (
              cell.value
                .toString()
                .toLowerCase()
                .indexOf(this.lazySearchText.toLowerCase()) >= 0
            )
          }, this)
        }, this)
        return filteredRows
      }

      return this.orderedRows
    },
    showedRows () {
      return this.tableRows.slice(0, this.countRowsToShow)
    }
  },
  methods: {
    rowClick (taskId) {
      switch (this.status) {
        case 'accepted':
          this.$router.push({ path: `/ad-agent/view-task/${taskId}` })
          break
        case 'outgoing':
          this.$router.push({ path: `/ad-agent/view-request/${taskId}` })
          break
        case 'incoming':
          this.$router.push({ path: `/view-request/${taskId}` })
          break
      }
    },
    statusFilterSelect (name) {
      this.activeFilterName = name
    },
    columnClick (sortName) {
      const sortOptions = {
        column: sortName
      }

      if (this.$store.getters.tasksSortColumn === sortName) {
        if (this.$store.getters.tasksSortDirection === sortTypes.ASC) {
          sortOptions.direction = sortTypes.DESC
        } else {
          sortOptions.direction = sortTypes.ASC
        }
      } else {
        sortOptions.direction = sortTypes.ASC
      }
      this.saveSortOptions(sortOptions)
    },
    loadTasksBaseOnStatus (status) {
      this.isLoadData = true
      switch (status) {
        case 'accepted':
          this.$eventBus.$emit('pageHeaderChange', 'Задачи')
          this.loadOutgoingTasks()
          this.loadActiveTasks()
            .then(() => {
              this.isLoadData = false
            })
            .catch(() => {
              this.isLoadData = false
            })
          break
        case 'outgoing':
        case 'incoming':
          this.$eventBus.$emit('pageHeaderChange', 'Заявки')
          this.loadOutgoingTasks()
            .then(() => {
              this.isLoadData = false
            })
            .catch(() => {
              this.isLoadData = false
            })
          break
      }
    },
    clearSearchText () {
      this.searchText = ''
    },
    checkScroll () {
      if (document.documentElement.scrollHeight - document.documentElement.scrollTop.toFixed() - document.documentElement.clientHeight <= 10 && document.documentElement.scrollTop > 0) {
        if (this.countRowsToShow < this.tableRows.length) {
        } this.countRowsToShow += countRowsToShow
      }
    },
    ...mapActions({
      loadActiveTasks: 'LOAD_ACTIVE_TASKS',
      loadOutgoingTasks: 'LOAD_OUTGOING_TASKS',
      saveSortOptions: 'SAVE_TASKS_TABLE_SORT'
    })
  },
  watch: {
    searchText: _.debounce(function (newValue) {
      this.lazySearchText = newValue
    }, 300),
    tableRows: function (newValue, prevValue) {
      if (newValue.length !== prevValue.length) {
        this.countRowsToShow = countRowsToShow
      }
    },
    status: function (val) {
      this.loadTasksBaseOnStatus(val)
    }
  },
  created () {
    this.loadTasksBaseOnStatus(this.status)
    if (
      !this.$store.getters.tasksSortColumn ||
      !this.$store.getters.tasksSortDirection
    ) {
      this.saveSortOptions({
        column: this.tableColumns[0].sortName,
        direction: sortTypes.ASC
      })
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', _.debounce(this.checkScroll, 150))
  },
  mounted () {
    window.addEventListener('scroll', _.debounce(this.checkScroll, 150))
  }
}
</script>

<style>
</style>
